<template>
  <div class="floating-menu">
    <router-link class="floating-menu__icon" :to="{ name: 'home' }">
      <a-icon type="home" />
    </router-link>
    <router-link
      class="floating-menu__icon"
      :to="{ name: 'transaction-request' }"
    >
      <a-icon type="swap" />
    </router-link>
    <router-link class="floating-menu__icon" :to="{ name: 'buy' }">
      <a-icon type="shopping-cart" />
    </router-link>
  </div>
</template>
<script>
export default {
  name: "FloatingMenu",
  computed: {
    isRoulettesRoute() {
      return this.$route.name === "roulettes";
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.floating-menu {
  position: fixed;
  z-index: 1000;
  top: 20px;
  right: 20px;
  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
    background: var(--primary);
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    color: var(--white);
    transition: background 0.3s, color 0.3s;
    &:hover {
      background: var(--hover);
      color: var(--white);
      text-decoration: none;
    }
    .anticon {
      font-size: 24px;
    }
  }
}
</style>
